import { render, staticRenderFns } from "./DiscountsEdit.vue?vue&type=template&id=b17c932e"
import script from "./DiscountsEdit.vue?vue&type=script&lang=js"
export * from "./DiscountsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports